import { Box, Button, Link, Typography } from '@material-ui/core';
import { Checkbox, QuestionMarkIcon } from 'Components';
import { useLocalization } from 'Hooks';
import { routePath } from 'Navigator/routes';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  AccountState,
  onUpdateOnlinePermissionRequest,
  setUserAcceptedNewVersion,
  setUserAcceptedNewVersionV2,
  setUserAcceptedCerceve,
  setUserAcceptedAcikRiza,
  setUserAcceptedTicari,
  setUserAcceptedTicariEposta,
  setUserAcceptedTicariSms,
  storeAccount,
} from 'Stores/Account';
import { onInıtDataStore, storeApp } from 'Stores/App';
import { onUpdateCommercialStatusRequest, updateAgreementList, UserState, userStore } from 'Stores/User';
import { colors, fontSizes, gutters } from 'Theme/Variables';
import { generateLanguageParam, paranthesisNormalize } from 'Utils';

import './UpdateAgreements.scss';

const UpdateAgreements: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userData: UserState = useSelector(userStore);
  const accountState: AccountState = useSelector(storeAccount);
  const onInıtData = useSelector(onInıtDataStore);
  const appState = useSelector(storeApp);
  const userAccepted = accountState.userAcceptedNewVersion;
  const userAcceptedV2 = accountState.userAcceptedNewVersionV2;
  const userAcceptedCerceve = accountState.userAcceptedCerceve;
  const userAcceptedAcikRiza = accountState.userAcceptedAcikRiza;
  const userAcceptedTicari = accountState.userAcceptedTicari;
  const userAcceptedTicariEposta = accountState.userAcceptedTicariEposta;
  const userAcceptedTicariSms = accountState.userAcceptedTicariSms;
  const isRILoginWithOpenIdForce = appState?.isRILoginWithOpenIdForce;
  const { AgreementList } = onInıtData;
  const { currentAgreementList } = userData;

  const {
    web_updated_contracts_header,
    web_updated_contracts_info,
    web_updated_contracts_info_desc,
    web_account_explicit_consent_text_info,
    web_clarification_text,
    web_read_accept,
    web_framework_contract,
    web_title_commercial_electronic_communication_permission_text,
  } = useLocalization();

  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;

  const confirmAgreements = () => {
    // RILoginWithOpenIdForce true ise 6, 7 (zorunlu) + 4, 3 (opsiyonel) gönderilir
    if (isRILoginWithOpenIdForce) {
      const agreement6Version = AgreementList.find((item: any) => item.AgreementType === 6)?.AgreementVersion;
      const agreement7Version = AgreementList.find((item: any) => item.AgreementType === 7)?.AgreementVersion;
      
      // Payload'ı dinamik olarak oluştur - sadece zorunlu olanları ekle
      const onlinePermissionMessage: any = {
        6: agreement6Version, // Çerçeve sözleşmesi - zorunlu
        7: agreement7Version, // Aydınlatma metni - zorunlu (KVKK gereği)
      };
      
      // Opsiyonel sözleşmeleri sadece onaylandıysa ekle
      if (userAcceptedAcikRiza) {
        onlinePermissionMessage[4] = AgreementList.find((item: any) => item.AgreementType === 4)?.AgreementVersion;
      }
      
      // Ticari izin OnUpdateCommercialStatus servisi ile ayrıca gönderilecek, burada eklenmeyecek
      
      const payload = {
        Language: generateLanguageParam(),
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        OnlinePermissionMessage: onlinePermissionMessage,
      };
      dispatch(onUpdateOnlinePermissionRequest(payload));
      
      // Ticari izin için OnUpdateCommercialStatus servisini çağır
      if (userAcceptedTicariEposta || userAcceptedTicariSms) {
        // E-posta ve SMS seçimlerine göre CommercialStatusChannelType belirle
        // 1 = Sadece SMS, 2 = Sadece E-posta, 3 = Her ikisi
        let commercialStatusChannelType = 0;
        if (userAcceptedTicariSms && !userAcceptedTicariEposta) {
          commercialStatusChannelType = 1;
        } else if (!userAcceptedTicariSms && userAcceptedTicariEposta) {
          commercialStatusChannelType = 2;
        } else if (userAcceptedTicariSms && userAcceptedTicariEposta) {
          commercialStatusChannelType = 3;
        }
        
        if (commercialStatusChannelType > 0) {
          dispatch(
            onUpdateCommercialStatusRequest({
              CustomerNumber: customerNumber,
              SessionToken: sessionToken,
              CommercialStatusChannelType: commercialStatusChannelType,
              Language: generateLanguageParam(),
            })
          );
        }
      }
      
      dispatch(updateAgreementList(onInıtData?.AgreementList));
      return;
    }

    const agreement1 = currentAgreementList?.find((item: any) => item?.AgreementType === 1);
    const agreement2 = currentAgreementList?.find((item: any) => item?.AgreementType === 2);
    const agreement5 = currentAgreementList?.find((item: any) => item?.AgreementType === 5);

    const agreement4 = userAcceptedV2
      ? AgreementList.find((item: any) => item.AgreementType === 4)?.AgreementVersion //currentAgreementList.find((item: any) => item.AgreementType === 4)?.AgreementVersion
      : currentAgreementList?.find((item: any) => item?.AgreementType === 4)?.AgreementVersion;

    // Normal akış için payload oluştur
    const normalOnlinePermissionMessage: any = {
      1: agreement1 ? AgreementList.find((item: any) => item.AgreementType === 1)?.AgreementVersion : undefined,
      2: agreement2 ? AgreementList.find((item: any) => item.AgreementType === 2)?.AgreementVersion : undefined,
      4: agreement4,
      5: agreement5 ? AgreementList.find((item: any) => item.AgreementType === 5)?.AgreementVersion : undefined,
      6: AgreementList.find((item: any) => item.AgreementType === 6)?.AgreementVersion,
      7: AgreementList.find((item: any) => item.AgreementType === 7)?.AgreementVersion,
    };
    
    // Ticari izni kontrol et
    if (userAcceptedTicari) {
      normalOnlinePermissionMessage[3] = AgreementList.find((item: any) => item.AgreementType === 3)?.AgreementVersion;
    }

    dispatch(
      onUpdateOnlinePermissionRequest({
        Language: generateLanguageParam(),
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        OnlinePermissionMessage: normalOnlinePermissionMessage,
      })
    );
    dispatch(updateAgreementList(onInıtData?.AgreementList));
  };

  const checkExplicittVersion = () => {
    const explicitCurrentAcceptedVersion = currentAgreementList?.find((item: any) => item?.AgreementType === 4);
    const explicitApplicationVersion = AgreementList.find((item: any) => item.AgreementType === 4);
    return explicitCurrentAcceptedVersion !== explicitApplicationVersion;
  };

  return (
    <div id="updateAgreements">
      <div className="updateAgreements">
        <Typography variant="h3">
          <Box marginTop={gutters.big} textAlign="center" fontWeight={600}>
            {web_updated_contracts_header}
          </Box>
        </Typography>
        <Box className="updateAgreements__alert-box">
          <QuestionMarkIcon color={colors.secondary} width="32px" height="32px" />
          <Box paddingLeft={gutters.regular}>
            <Typography variant="h3">
              <Box fontSize={fontSizes.regular} fontWeight={600}>
                {web_updated_contracts_info}
              </Box>
            </Typography>
            <Typography>
              <Box mt={gutters.small}>{web_updated_contracts_info_desc}</Box>
            </Typography>
          </Box>
        </Box>
        <Box mt={gutters.big} className="updateAgreements__check-container">
          <Checkbox
            name="explicit"
            color="primary"
            onClick={() => {
              if (!userAccepted) {
                history.push(routePath.homeAgreementUpdate);
              } else {
                dispatch(setUserAcceptedNewVersion(false));
              }
            }}
            checked={userAccepted}
            label={
              <Typography variant="h3" align="center">
                <Box fontSize={fontSizes.regular} fontWeight={600}>
                  <Link
                    underline="always"
                    color="secondary"
                    href={routePath.homeAgreementUpdate}
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      e.stopPropagation();
                      history.push(routePath.homeAgreementUpdate);
                    }}
                    itemID="showSmsPermissionBtnTest"
                  >
                    {paranthesisNormalize(web_clarification_text)}
                  </Link>
                </Box>
              </Typography>
            }
            marginBottomGutter="0"
          />
        </Box>
        {/* RILoginWithOpenIdForce true ise Type 4 (Açık Rıza) checkbox'ını göster - ZORUNLU DEĞİL */}
        {isRILoginWithOpenIdForce && (
          <Box mt={gutters.small} className="updateAgreements__check-container">
            <Checkbox
              name="acikRiza"
              color="primary"
              onClick={() => {
                if (!userAcceptedAcikRiza) {
                  history.push(routePath.homeAgreementAcikRiza);
                } else {
                  dispatch(setUserAcceptedAcikRiza(false));
                }
              }}
              checked={userAcceptedAcikRiza}
              label={
                <Typography variant="h3" align="center">
                  <Box fontSize={fontSizes.regular} fontWeight={600}>
                    <Link
                      underline="always"
                      color="secondary"
                      href={routePath.homeAgreementAcikRiza}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        history.push(routePath.homeAgreementAcikRiza);
                      }}
                      itemID="showAcikRizaBtnTest"
                    >
                      {paranthesisNormalize(web_account_explicit_consent_text_info)}
                    </Link>
                  </Box>
                </Typography>
              }
              marginBottomGutter="0"
            />
          </Box>
        )}
        {/* RILoginWithOpenIdForce true ise Type 6 (Çerçeve Sözleşmesi) checkbox'ını göster */}
        {isRILoginWithOpenIdForce && (
          <Box mt={gutters.small} className="updateAgreements__check-container">
            <Checkbox
              name="cerceve"
              color="primary"
              onClick={() => {
                if (!userAcceptedCerceve) {
                  history.push(routePath.homeAgreementCerceve);
                } else {
                  dispatch(setUserAcceptedCerceve(false));
                }
              }}
              checked={userAcceptedCerceve}
              label={
                <Typography variant="h3" align="center">
                  <Box fontSize={fontSizes.regular} fontWeight={600}>
                    <Link
                      underline="always"
                      color="secondary"
                      href={routePath.homeAgreementCerceve}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        history.push(routePath.homeAgreementCerceve);
                      }}
                      itemID="showCerceveSozlesmeBtnTest"
                    >
                      {paranthesisNormalize(web_framework_contract)}
                    </Link>
                  </Box>
                </Typography>
              }
              marginBottomGutter="0"
            />
          </Box>
        )}
        {/* RILoginWithOpenIdForce true ise Type 3 (Ticari Elektronik İzin) - E-posta checkbox'ını göster - ZORUNLU DEĞİL */}
        {isRILoginWithOpenIdForce && (
          <Box mt={gutters.small} className="updateAgreements__check-container">
            <Checkbox
              name="ticariEposta"
              color="primary"
              onClick={() => {
                if (!userAcceptedTicariEposta) {
                  history.push(routePath.homeAgreementTicariEposta);
                } else {
                  dispatch(setUserAcceptedTicariEposta(false));
                }
              }}
              checked={userAcceptedTicariEposta}
              label={
                <Typography variant="h3" align="center">
                  <Box fontSize={fontSizes.regular} fontWeight={600}>
                    <Link
                      underline="always"
                      color="secondary"
                      href={routePath.homeAgreementTicariEposta}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        history.push(routePath.homeAgreementTicariEposta);
                      }}
                      itemID="showTicariEpostaBtnTest"
                    >
                      {paranthesisNormalize(web_title_commercial_electronic_communication_permission_text)}
                    </Link>{' '}
                    (E-posta)
                  </Box>
                </Typography>
              }
              marginBottomGutter="0"
            />
          </Box>
        )}
        {/* RILoginWithOpenIdForce true ise Type 3 (Ticari Elektronik İzin) - SMS checkbox'ını göster - ZORUNLU DEĞİL */}
        {isRILoginWithOpenIdForce && (
          <Box mt={gutters.small} className="updateAgreements__check-container">
            <Checkbox
              name="ticariSms"
              color="primary"
              onClick={() => {
                if (!userAcceptedTicariSms) {
                  history.push(routePath.homeAgreementTicariSms);
                } else {
                  dispatch(setUserAcceptedTicariSms(false));
                }
              }}
              checked={userAcceptedTicariSms}
              label={
                <Typography variant="h3" align="center">
                  <Box fontSize={fontSizes.regular} fontWeight={600}>
                    <Link
                      underline="always"
                      color="secondary"
                      href={routePath.homeAgreementTicariSms}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        history.push(routePath.homeAgreementTicariSms);
                      }}
                      itemID="showTicariSmsBtnTest"
                    >
                      {paranthesisNormalize(web_title_commercial_electronic_communication_permission_text)}
                    </Link>{' '}
                    (SMS)
                  </Box>
                </Typography>
              }
              marginBottomGutter="0"
            />
          </Box>
        )}
        {/* RILoginWithOpenIdForce true değilse Type 4 (Açık Rıza) checkbox'ını göster */}
        {!isRILoginWithOpenIdForce && checkExplicittVersion() && (
          <Box mt={gutters.small} className="updateAgreements__check-container">
            <Checkbox
              name="explicit"
              color="primary"
              onClick={() => {
                if (!userAcceptedV2) {
                  history.push(routePath.HomeAgreementEcplicit);
                } else {
                  dispatch(setUserAcceptedNewVersionV2(false));
                }
              }}
              checked={userAcceptedV2}
              label={
                <Typography variant="h3" align="center">
                  <Box fontSize={fontSizes.regular} fontWeight={600}>
                    <Link
                      underline="always"
                      color="secondary"
                      href={routePath.HomeAgreementEcplicit}
                      onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        history.push(routePath.HomeAgreementEcplicit);
                      }}
                      itemID="showSmsPermissionBtnTest"
                    >
                      {paranthesisNormalize(web_account_explicit_consent_text_info)}
                    </Link>
                  </Box>
                </Typography>
              }
              marginBottomGutter="0"
            />
          </Box>
        )}
        <Box mt={gutters.big} />
        <Button
          className={
            isRILoginWithOpenIdForce
              ? (!userAccepted || !userAcceptedCerceve ? 'disabled' : '')
              : (!userAccepted ? 'disabled' : '')
          }
          disabled={
            isRILoginWithOpenIdForce
              ? !userAccepted || !userAcceptedCerceve
              : !userAccepted
          }
          variant="contained"
          fullWidth
          color="secondary"
          onClick={confirmAgreements}
        >
          Devam et
        </Button>
      </div>
    </div>
  );
};

export default UpdateAgreements;
